<template>
<div>
  <router-view />
  <div class="q-pa-md">
    <div class="q-pa-md q-gutter-sm">
      <q-breadcrumbs>
        <q-breadcrumbs-el icon="home" to="/home" />
        <q-breadcrumbs-el
          label="Price Tracker"
          icon="widgets"
          to="/pricewatch"
        />
        <q-breadcrumbs-el
          label="Products"
          icon="navigation"
          to="/pricewatch/products"
        />
      </q-breadcrumbs>
    </div>
 <!--   <button class="btn2" style="width:10rem;margin-left:85%;margin-bottom:20px">Search History</button>   -->
  <div class="complete">
      <div class ="products">
        <div class="inp"><input id="0" v-model="AllData[0].product" type="text" placeholder="Product Name (e.g.-Oppo F17 Mobile 4GB RAM)"/></div>
        <div class="url">
          <input v-model="AllData[0].cost" type="text" placeholder="Enter the Product Cost">
          <input v-if="show1[0]" v-model="AllData[0].comp[0]" type="text" placeholder="Enter URL to competitor 1" />
          <input v-if="show1[1]" v-model="AllData[0].comp[1]" type="text"  placeholder="Enter URL to competitor 2"/>
          <input v-if="show1[2]" v-model="AllData[0].comp[2]" type="text" placeholder="Enter URL to competitor 3"/>
          <input v-if="show1[3]" type="text" placeholder="Enter URL to competitor 4"/>
          <input v-if="show1[4]" type="text" placeholder="Enter URL to competitor 5"/>
        </div>
        <button v-if="count1<3" v-on:click="disp" class="btn">Add More URL</button>
      
      </div>
      <div v-if="prod[1]" class ="products">
        <div class="inp"><input v-model="AllData[1].product" type="text" placeholder="Product Name"/></div>
        <div class="url">
          <input v-model="AllData[1].cost" type="text" placeholder="Enter the Product Cost">
          <input v-if="show2[0]" v-model="AllData[1].comp[0]" type="text" placeholder="Enter URL to competitor 1" />
          <input v-if="show2[1]" v-model="AllData[1].comp[1]" type="text"  placeholder="Enter URL to competitor 2"/>
          <input v-if="show2[2]" v-model="AllData[1].comp[2]" type="text" placeholder="Enter URL to competitor 3"/>
          <input v-if="show2[3]" type="text" placeholder="Enter URL to competitor 4"/>
          <input v-if="show2[4]" type="text" placeholder="Enter URL to competitor 5"/>
        </div>
        <button v-if="count2<3" v-on:click="disp2" class="btn">Add More URL</button>
      
      </div>
      <div v-if="prod[2]" class ="products">
        <div class="inp"><input v-model="AllData[2].product" type="text" placeholder="Product Name"/></div>
        <div class="url">
          <input v-model="AllData[2].cost" type="text" placeholder="Enter the Product Cost">
          <input v-if="show3[0]" v-model="AllData[2].comp[0]" type="text" placeholder="Enter URL to competitor 1" />
          <input v-if="show3[1]" v-model="AllData[2].comp[1]" type="text"  placeholder="Enter URL to competitor 2"/>
          <input v-if="show3[2]" v-model="AllData[2].comp[2]" type="text" placeholder="Enter URL to competitor 3"/>
          <input v-if="show3[3]" type="text" placeholder="Enter URL to competitor 4"/>
          <input v-if="show3[4]" type="text" placeholder="Enter URL to competitor 5"/>
        </div>
        <button v-if="count3<3" v-on:click="disp3" class="btn">Add More URL</button>
      
      </div>
  <div style="margin-right: 350px" ><button v-if="countp<3" v-on:click="disp_prod" class="btn" >Add More Products</button></div>
  </div>
  <!-- <div class="err"><ul>
    <li v-for="item in errors" v-bind:key="item">{{item}}</li>
    </ul></div>
    -->
 <!-- <button class="btn2" v-on:click="onsubmit">Submit</button>    -->
  <div class="row">
          <div class="column">
     <!--       <router-link
              to="/pricewatch/products"
              style="text-decoration: none; color: inherit"
            >
            -->
          <button v-on:click="onsubmit1" style="border:0px;cursor:pointer">    <div class="card-i">
                <img class="cardimg" src="../../assets/revenue.png" />

                <q-card-section>Revenue</q-card-section>
                
              </div>
              </button>
       <!--     </router-link>    -->
          </div>
          <div class="column">
     
          <button v-on:click="onsubmit2" style="border:0px;cursor:pointer">    <div class="card-i">
                <img class="cardimg" src="../../assets/revenue.png" />

                <q-card-section>Market Share</q-card-section>
                
              </div>
              </button>
       
          </div>
          </div>
</div>

    </div>
</template>
<script>
import axios from 'axios';
  export default{
    name:"Products",
    data()
    {
      return {
        api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
        show1:[true],
        count1:1,
        prod:[true],
        countp:1,
        show2:[true],
        count2:1,
        show3:[true],
        count3:1,
        errors:[],
        AllData:[
          {
            product:"",
            cost:"",
            comp:["","",""],
          },
          {
            product:"",
            cost:"",
            comp:["","",""],
          },
          {
            product:"",
            cost:"",
            comp:["","",""],
          },
        ],
        pricewatchlist:[],
        obj:{
          product_name:"",
          url_list:[],
        }
      }
    },
    methods:{
        disp(){
          
            this.show1.push(true);
            console.log(this.show1);
            this.count1++;   
        },
        disp2(){
          
            this.show2.push(true);
            console.log(this.show2);
            this.count2++;   
        },
        disp3(){
            this.show3.push(true);
            console.log(this.show3);
            this.count3++;   
        },
        disp_prod()
        {
          this.prod.push(true);
          this.countp++;
        },
        validate(url) {  
        var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/; 
        if (pattern.test(url)) { 
          //  alert("Url is valid"); 
            return true; 
        }  
          //  alert("Url is not valid!"); 
            return false; 
 
    } ,
    submitUtil(selectedProductList) {
      return selectedProductList;
    },

    checkError()
    {
          // this.validate(this.AllData[0].comp[0]);         //https://stackoverflow.com 
       this. errors=[];
       if(this.AllData[0].product.trim()=="" && this.AllData[1].product.trim()=="" && this.AllData[2].product.trim()=="" )
       {
         this.errors.push("Atleast One Product Required");
         this.$q.notify({
          message: "Atleast One Product Required",
          color: "grey-3",
          textColor: "red",
        });
         return ;
        // document.getElementById("0").style.border="2px solid red";
       }
        for(let i=0;i<3;i++)
        {
          if(this.AllData[i].product=="")
          {
            for(let j=0;j<3;j++)
            {
              let url=this.AllData[i].comp[j];
              if(url!="")
              {
                  this.errors.push("Product Name is required ");
                  this.$q.notify({
                  message: "Product Name is Required Required",
                  color: "grey-3",
                  textColor: "red",
                });
                  return ;
              }
              if(url!="" && this.validate(url)==false)
              {
                this.errors.push("URL is invalid");
                this.$q.notify({
                  message: "URL is invalid",
                  color: "grey-3",
                  textColor: "red",
                });
                return ;
              }
            }
          }
          else 
          {
            if(this.AllData[i].comp[0].trim()=="" && this.AllData[i].comp[1].trim()=="" && this.AllData[i].comp[2].trim()=="")
            {
                this.errors.push("Atleat One competitor Required");
                this.$q.notify({
                  message: "Atleat One competitor Required",
                  color: "grey-3",
                  textColor: "red",
                });
                return ;
            }
            else 
            {
              for(let j=0;j<3;j++)
            {
              let url=this.AllData[i].comp[j].trim();
              if(url!="" && this.validate(url)==false)
              {
                this.errors.push("URL is invalid");
                this.$q.notify({
                  message: "URL is invalid",
                  color: "grey-3",
                  textColor: "red",
                });
                return ;
              }
            }

            }
          }
        }
        console.log(this.errors);
    },
        onsubmit1()
        {
          this.checkError();
        if(this.errors.length==0)
        {
        //  alert("No errors");
          for(let i=0;i<3;i++)
          {    this.obj={
              product_name:"",
              cost:"",
              type:"revenue",
              url_list:[],
          };
              if(this.AllData[i].product.trim()!="")
              {
                
                this.obj.product_name=this.AllData[i].product.trim();
                this.obj.cost=this.AllData[i].cost;
                for(let j=0;j<3;j++)
                {
                  if(this.AllData[i].comp[j].trim()!="")
                  {
                    this.obj.url_list.push(this.AllData[i].comp[j].trim());
                  }
                }
          
                this.pricewatchlist.push(this.obj);
              }
              
          }
          let postURL = this.api_url + `/products/trigger_price_watch`;
      
          this.$http
          .post(postURL,this.submitUtil(this.pricewatchlist))
          .then((response)=>{
            if (response.data) {
                
                this.$q.notify({
                  message: "Added to Price Tracker",
                  color: "grey-3",
                  textColor: "blue",
                });
                
                this.$router.push({
                  name: "PriceWatchResultHistory",
                });
                
              } else {
                this.$q.notify({
                  message: "Error Occured!",
                  color: "grey-5",
                  textColor: "negative",
                });
              }
              
          });
      /*    await axios.post("http://localhost:3000/pricewatch_request_list",{
            pricewatchlist:this.pricewatchlist,    
      }); 
      */
      
    //  return this.pricewatchlist;
    //        location.reload();
        }
        },
         onsubmit2()
        {
      //    alert("from submit 2");
          this.checkError();
        if(this.errors.length==0)
        {
        //  alert("No errors");
          for(let i=0;i<3;i++)
          {    this.obj={
              product_name:"",
              cost:"",
              type:"market_share",
              url_list:[],
          };
              if(this.AllData[i].product.trim()!="")
              {
                
                this.obj.product_name=this.AllData[i].product.trim();
                this.obj.cost=this.AllData[i].cost;
                for(let j=0;j<3;j++)
                {
                  if(this.AllData[i].comp[j].trim()!="")
                  {
                    this.obj.url_list.push(this.AllData[i].comp[j].trim());
                  }
                }
          
                this.pricewatchlist.push(this.obj);
              }
              
          }
          let postURL = this.api_url + `/products/trigger_price_watch`;
      
          this.$http
          .post(postURL,this.submitUtil(this.pricewatchlist))
          .then((response)=>{
            if (response.data) {
                
                this.$q.notify({
                  message: "Added to Price Tracker",
                  color: "grey-3",
                  textColor: "blue",
                });
                
                this.$router.push({
                  name: "PriceWatchResultHistory",
                });
                
              } else {
                this.$q.notify({
                  message: "Error Occured!",
                  color: "grey-5",
                  textColor: "negative",
                });
              }
              
          });
      /*    await axios.post("http://localhost:3000/pricewatch_request_list",{
            pricewatchlist:this.pricewatchlist,    
      }); 
      */
      
    //  return this.pricewatchlist;
    //        location.reload();
        }
        },
    },
    
  }
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Proza+Libre&display=swap');
.complete{
  border:2px solid dodgerblue;
  padding:5px;
  width:60%;
  margin:auto;
  border-radius: 5px;
  background-color: white;
  padding-bottom:12px;
  
}
  .products{
    width:90%;
    height:auto;
    border:1px solid dodgerblue;
    margin:auto;
    padding:15px;
    background-color: rgb(202, 225, 248);
    border-radius:5px;
    margin-top:8px;
  }
  
  .inp input{
    width:98%;
    border-radius: 8px;
    font-size:1.3rem;
    padding:0.2rem;
    margin:0.3rem;
    border:0px;
   /* font-family: 'Proza Libre', sans-serif;   */
  }

  .url{
      display:flex;
      flex-direction:column;
       justify-content: center;
      align-items:center ;  
  }

  .url input{
      width:80%;
      margin:0.1rem;
      font-size:1.1rem;
      padding:0.1rem;
      border:0px;
  }

  .btn{
    display: block;
    background-color: dodgerblue;
    border:1px solid dodgerblue;
    border:0px;
    margin:auto;
    margin-top:12px;
    font-size: 1.1rem;
    padding:0.2rem;
    border-radius: 5px;
    color:white;
    cursor:pointer;
    font-family: 'Baloo 2', cursive;
  }
  .btn2{
    background-color: rgb(255,0,0);
    font-size:1.2rem;
    padding:0.2rem;
    color:white;
    font-weight:bold;
    cursor:pointer;
    border:0px;
    border-radius:5px;
    width:6rem;
    margin-left: 70%;
    margin-top:5px;
    font-family: 'Baloo 2', cursive;
  }
  .btn:hover {
    background-color: rgb(3, 118, 233);
  }
  .btn2:hover{
    background-color: rgb(253, 52, 52);
  }
  .err{
    width:60%;
    margin:auto;
    color:red;
  }
  .card-i {
  box-shadow: 0px 5px 15px -2px rgb(26 108 220);
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  background-color: #f1f1f1;
  width: auto;
  max-height: 8rem;
  max-width: 8rem;
  margin: auto;
  transition:all 500ms ease;
}
.card-i:hover{
  background-color: #b8b8b8;
}
.cardimg {
  text-align: center;
  margin: auto;
  height: 3rem;
  width: 3rem;
  min-height: 50px;
  min-width: 50px;
  margin-top: 10px;
}

.icon {
  text-align: center;
  margin: auto;
  height: 1rem;
  width: 1rem;
  min-height: 15px;
  min-width: 15px;
  /*margin-top: 10px;*/
}
.q-card__section--vert {
  padding: 0;
}
.column {
  float: left;
  height:8rem;
  width:100%;
  max-height: 10rem;
  max-width: 10rem;
  padding: 0 10px;
}

/* Remove extra left and right margins, due to padding */
.row {
  margin-top: 3rem;
  align-items: center;
  justify-content: center;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>


